<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 5H22V7H19V10H17V7H14V5H17V2H19V5ZM17 19V13H19V21H3V5H11V7H5V19H17Z" fill="#6C6C7D" />
  </svg>
</template>

<script>
  export default {
    name: "ShapeSquareIcon",
  };
</script>

<style></style>
